import {Component, OnInit} from '@angular/core';
import {Events} from "../../../framework/providers/events";
import {MenuController, NavController, PopoverController, ViewDidEnter} from "@ionic/angular";
import {BusinessService} from "../../../core/services/BusinessService";
import {OrderService} from "../../../core/services/OrderService";
import {ModelProvider} from "../../../framework/providers/modelProvider/ModelProvider";
import {AppDataService} from "../../../core/services/AppDataService";
import {ModelToolsProvider} from "../../../framework/providers/model-tools/model-tools";
import {AdminService} from "../services/AdminService";
import {ActivatedRoute, NavigationExtras} from "@angular/router";
import {MainService} from "../../../core/services/MainService";

@Component({
    selector: 'app-taarif',
    templateUrl: './taarif.page.html',
    styleUrls: ['./taarif.page.scss'],
})
export class TaarifPage implements ViewDidEnter, OnInit {
    ready = true;
    loading = false;
    tableData;
    menu = {};
    currentOpenSection;
    exTableData;
    exTableData2;

    userOpenBox;
    showSystemMenu = true;
    boxMenu = false;

    sideModels;
    showLoading = true;
    showDetails = false;

    refreshTimeout;
    currentSection;

    myprefix = "selectTablePrefix3" + Math.floor(Math.random() * Math.floor(1000));
    appUser;
    currentUserType;

    constructor(public events: Events,
                public popoverCtrl: PopoverController,
                public menuService: MainService,
                private menuCtrl: MenuController,
                public business: BusinessService,
                public navCtrl: NavController,
                public mainService: MainService,
                public orderService: OrderService,
                public modelProvider: ModelProvider,
                public appData: AppDataService,
                public modelTools: ModelToolsProvider,
                public businessService: BusinessService,
                public adminService: AdminService,
                public route: ActivatedRoute) {
    }

    ionViewDidEnter() {
        console.log('Page did enter (now active)');
        // this.mainService.closeMenu(null, true, true);
        // this.mainService.closeMenu('leftAdmin', true, false);
        // this.mainService.closeMenu('rightAdmin', true, false);
    }

    ngOnInit(): void {
        let me = this;
        this.appUser = this.orderService.getAppUser();

        this.events.subscribe('chooseOpenBox' + this.myprefix, (data) => {

            //project task open in popup hack
            if (data['sectionName'] == 'projectTask') {
                this.adminService.popupEditBoxNav(null, 'projectTask',
                    this.exTableData, 'fopqwwqdd', null, this.navCtrl);
            } else
                this.setUserOpenBox(data);
        });

        this.events.subscribe('on_manageModels_load', (data) => {
            console.log('on_manageModels_load!!!')
            if (!this.adminService.manageModels['menuData']) {
                return
            }
            if (!this.currentSection) this.currentSection = this.adminService.manageModels['menuData'][0];

            if (!this.adminService.manageModels) return;

            if (!me.sideModels) {
                me.sideModels = [this.adminService.manageModels['menuData'][1],
                    this.adminService.manageModels['menuData'][2],
                    this.adminService.manageModels['menuData'][3], this.adminService.manageModels['menuData'][4]];

                // this.setLeftSideProfile(this.adminService.manageModels['mainMenu']);

                if (this.adminService.manageModels['menuData'].length > 4) {
                    this.showDetails = false;
                }

                /*????*/
                if (this.adminService.manageModels['menuData'].length == 1) {
                    this.events.publish('showMenu',
                        {
                            'force': false,
                            'menu': 'rightAdmin',
                            'prefix': 'tarrif',
                            'adminSideMenu': true,
                            'sideModels': this.sideModels
                        });
                    this.showSystemMenu = false;
                } else {
                    me.adminService.openSideMenus(me.sideModels);
                }
            }

            this.showLoading = false;

            me.ready = false;
            setTimeout(function () {
                me.ready = true;
                me.showLoading = false;
            }, 1);

        });
        this.events.subscribe('showSystemMenu', (data) => {
            me.showSystemMenu = true;
        })

        //TODO: do not commit this.
        if (true) {
            setTimeout(function () {
                // me.adminService.goToAdmin(me.navCtrl, 'homePage', null, 244342);
                // me.adminService.goToAdmin(me.navCtrl, 'taarif', null, 79);
                // me.adminService.goToAdmin(me.navCtrl, 'lead', null, null);
                // me.adminService.goToAdmin(me.navCtrl, 'orderDetails', null, 484);
                // me.adminService.goToAdmin(me.navCtrl, 'form', null, null);
                // me.adminService.goToAdmin(me.navCtrl, 'addressDetails', null, 1297);
                // me.modelTools.goTo('reports');
            }, 1);
        }

        this.events.subscribe('change_admin_home', (data) => {
            this.showSystemMenu = false;
            this.loadDashboard(data['appUserTypeId'], data['row']);
        });
        this.loadDashboard();

        this.events.subscribe('refresh_admin', (data) => {
            this.force_refresh();
        })
        this.events.subscribe('adminMenuNav', (data) => {
            this.boxMenu = !this.boxMenu;
            this.showSystemMenu = !this.showSystemMenu;
        })
        // this.events.subscribe('refresh_admin', (data) => {
        //     this.events.publish('resetHome' + me.myprefix, {'tableData': this.adminService.manageModels});
        // })
        // this.mainService.closeMenu('menuAdmin', true);
    }

    ionViewWillEnter() {
    }

    setLeftSideProfile(homeData) {
        if (this.sideModels) this.sideModels[2] = homeData;
    }

    force_refresh() {
        this.adminService.forceRefersh();
        let mfilters = {
            'cach_prefix': "homePage_" + this.currentUserType,
            'getDashboard': 1,
            'userTypeId': this.currentUserType
        }
        this.adminService.loadAdmin(mfilters);
        this.refresh();
    }

    setUserOpenBox(data) {
        if (this.userOpenBox == data['sectionName']) {
            this.userOpenBox = null;
        } else {
            this.userOpenBox = null;
            let me = this;
            setTimeout(function () {
                me.userOpenBox = data['sectionName'];
            }, 500);
        }
    }

    refresh() {
        //tmp fix. for agents auto load every thing.
        if (!this.orderService.isStaff()) {
            this.modelTools.setKey('adminData', null);
        }

        let me = this;
        this.ready = false;
        me.showLoading = true;
        setTimeout(function () {
            me.ready = true;
            me.showLoading = false;
            me.adminService.openSideMenus(me.sideModels);
        });
    }

    ngOnDestroy(): void {
        this.events.unsubscribe('on_manageModels_load');
        this.events.unsubscribe('refreshAdmin')
        this.events.unsubscribe('adminMenuNav')
        // this.events.unsubscribe('showAdminMenu');
    }

    async presentSelectBar(myEvent, type, isbig = false) {
        this.adminService.popupEditBox(myEvent, null, this.exTableData, "asdasdqwdqwdqw",
            null, type, false,
            null, null, null, null, null);

        // const popover = await this.popoverCtrl.create({
        //     component: SelectBarComponent,
        //     componentProps: {
        //         'prefix': 'aaaa',
        //         'exTableData': this.exTableData,
        //         'sectionName': null,
        //         'type': type
        //     },
        //     event: myEvent,
        //     animated: true,
        //     showBackdrop: true,
        //     cssClass: 'note-popover icenter-popover ' + (isbig ? 'bigger-popover' : 'smaller-popover')
        // });
        // return await popover.present();
    }

    openCustomModel(sectionName, menuIndex) {
        ////console.log'open custom model: ', sectionName);
        let params = {
            'menuIndex': menuIndex,
            'sectionName': sectionName
        };

        let navigationExtras: NavigationExtras = {
            queryParams: params
        };

        this.navCtrl.navigateForward('admin-model/' + sectionName, navigationExtras);
    }

    tableButtonClick(tablePrefix, key, data) {
        this.events.publish("btnclick_" + tablePrefix, {'key': key, 'data': data});
//     'addFilter'
// }, {'quickFieldFilter':[{'field':'status', 'value':counter['status__id']}]})
    }


    customEvent(key) {
        this.navCtrl.navigateForward(key);
    }

    chooseOpenBox(secName) {
        let me = this;
        if (me.userOpenBox == secName) {
            me.userOpenBox = null;
            return;
        }
        //else..
        me.userOpenBox = null;
        setTimeout(function () {
            me.userOpenBox = secName;
        }, 100);
    }

    openMenu() {
        this.adminService.closeMenu('menuAdmin', true);
    }

    loadDashboard(appUserTypeId = null, type = null, timeout = 0, fullLoading=false) {
        let me = this;
        me.showLoading = true;
        this.currentUserType = appUserTypeId;

        clearTimeout(me.refreshTimeout);
        me.refreshTimeout = setTimeout(function () {

            let filters = {'getDashboard': 1, 'fullLoading':fullLoading}
            if (appUserTypeId) {
                filters['userTypeId'] = appUserTypeId;
            }
            filters['cach_prefix'] = 'homePage_' + appUserTypeId;
            me.adminService.loadAdmin(filters, fullLoading).then(function (tableData: any) {
                me.events.publish('resetHome' + me.myprefix, {'tableData': tableData, 'type': type});
                me.setLeftSideProfile(type);
            });
        }, timeout);

        if (type) {
            this.currentSection = type;
        }
    }

}
